import { useEffect, useRef, useState } from "react";
import { Button, Carousel, Container } from "react-bootstrap";
import no_image from "../images/No_Image_Available.jpg";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { RWebShare } from "react-web-share";
import {
  generateRandomToken,
  getLocalStorageMenuItem,
  setLocalStorageMenuItem,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileSettings,
  setMobileTextColor,
} from "../utility";
import axios from "axios";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Cookies from "js-cookie";
import Toast from "../common/toast";
import i18next, { t } from "i18next";
import MianInfo from "../components/mobile screen/Item/mianInfo";
import OrderItem from "../components/mobile screen/Item/orderItem";
import SvgDynamicIconComponent from "../SvgDynamicIconComponent";
import Loading from "../common/loading";
import LoadingTreeDataDialog from "../components/mobile screen/mobileComponents/LoadingTreeDataDialog";


import ZoomInIcon from '@mui/icons-material/ZoomIn'; // Add for magnifier icon
import ZoomOutIcon from '@mui/icons-material/ZoomOut'; // Add for zoom out icon
import { Dialog, DialogContent } from '@mui/material'; // Add for modal dialog

const Item = ({ tableQr, tableName }) => {
  const navigate = useNavigate();
  const [menuTree, setMenuTree] = useState(
    getLocalStorageMenuItem("tree_data") || []
  );
  const [loadingTree, setLoadingTree] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState();
  const [calorie, setCalorie] = useState();
  const [priceOption, setPriceOption] = useState();
  const [favorites, setFavorites] = useState([]);
  const [favClickCount, setFavClickCount] = useState(-1);
  const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);

  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });
  const location = useLocation();

  var itemData = [];
  var sympoleData = "";
  var itemInRoot = false;

  const itemId = parseInt(searchParams.get("item"));
  var lang = getLocalStorageMenuItem("lang");

  const [isImageZoomed, setIsImageZoomed] = useState(false);

  const [zoomLevel, setZoomLevel] = useState(1);
  const [panPosition, setPanPosition] = useState({ x: 0, y: 0 });

  const toggleImageZoom = () => {
    setIsImageZoomed(!isImageZoomed);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const initializeLanguage = async () => {
      lang = getLocalStorageMenuItem("lang");

      if (!lang) {
        lang = searchParams.get("selectedLang");
        if (lang) {
          setLocalStorageMenuItem("lang", lang);
        } else {
          lang = "en";
        }
      }

      // Set the language in i18next
      await i18next.changeLanguage(lang);

      // Set loading to false after language change
      setLoading(false);
    };

    initializeLanguage();
  }, [searchParams]);

  const loadTree = async () => {
    setLoadingTree(true);
    try {
      const timeZone = getLocalStorageMenuItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang") || "",
            timeZone: timeZone.replace(/["]+/g, ''),
          },
        }
      );

      if (promise?.data?.data?.length === 0 || !promise?.data?.data?.details || !promise?.data?.data?.tree || !promise?.data?.data?.items) {
        setLoadingTreeDialog(true);
      }
      setMenuTree(promise?.data?.data || []);
      setLocalStorageMenuItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      setMobileSettings(promise?.data?.data?.details)

      return promise?.data?.data;
    } catch (error) {
      // Handle error
    } finally {
      setLoadingTree(false); // Hide progress dialog
    }
  };

  const loadTreeData = async () => {
    if (menuTree.length === 0 || !menuTree.details || !menuTree.tree || !menuTree.items) {
      loadTree();
    } else {
      const pathname = location.pathname;
      const pathSegments = pathname.split("/");
      const menu_code_number = pathSegments[2];
      const treeMenu_code_number = menuTree?.details?.code_number;
      if (menu_code_number !== treeMenu_code_number) {
        loadTree();
      }
    }
  };

  const is_suggested = searchParams.get("suggested");
  if (is_suggested) {
    if (is_suggested == 1) {
      itemData = menuTree?.items?.find((item) => item.id === itemId);
      sympoleData = menuTree?.details?.currency_symbol;
      itemInRoot = false;
    } else {
      itemData = menuTree?.items?.find((item) => item.id === itemId);
      sympoleData = menuTree?.details?.currency_symbol;
      itemInRoot = location.state?.in_root;
    }
  } else {
    itemData = menuTree?.items?.find((item) => item.id === itemId);
    sympoleData = menuTree?.details?.currency_symbol;
    itemInRoot = location.state?.in_root;
  }

  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(null);

  const VenuePublicDetails = getLocalStorageMenuItem("publicDetails");

  const { data: favoritesData, isLoading: favoritesIsLoading } = useQuery(
    "favorites",
    async () => {
      const favoritesFromCookie = getLocalStorageMenuItem("favorites");
      if (favoritesFromCookie) {
        const favoritesItems = favoritesFromCookie;
        const favoritesArray = favoritesItems?.map((item) => item.id);
        const promise = await axios.get(
          `${process.env.REACT_APP_API
          }/menus/${tableQr}/favourites?items=${JSON.stringify(
            favoritesArray
          )}`,
          { headers: { localization: lang } }
        );
        setFavorites(promise?.data.data.items);
        return promise;
      }
      setFavorites([]);
      return [];
    }
  );

  const updataItem = (element) => {
    searchParams.set("item", element.id);
    searchParams.set("suggested", 1);
    setSearchParams(searchParams);
  };

  const handleSelected = (element) => {
    const price_option_list = itemData?.has_price_option_item ? itemData?.price_option_items : itemData?.price_options;
    try {
      if (price_option_list) {
        const index = price_option_list.findIndex((option) => {
          return (option.price == element.price && option.name == element.name);
        });
        setSelected(price_option_list[index].name);
        setCalorie(price_option_list[index].calories);
        setPriceOption(price_option_list[index]);
      }
    } catch (error) { }
  };

  const handleFavorite = (item) => {
    setFavClickCount(favClickCount - 1);
    const index = favorites.findIndex((fav) => fav.id === item.id);
    var custom_item = {
      id: item.id,
      name: item.name,
      description: item.description,
      active: item.active,
      image: item.image,
      price: item.price,
      sold_out: item.sold_out,
      has_price_options: false,
      warnings: item.warnings,
    };
    if (index === -1) {
      const newFavorites = [...favorites, custom_item];
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));

      Cookies.set("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Added to favorites"));
    } else {
      // If item is already in favorites, remove it
      const newFavorites = favorites.filter(
        (favItem) => favItem.id !== item.id
      );
      setFavorites(newFavorites);
      Cookies.set("favorites", JSON.stringify(newFavorites));
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));

      handleOpenToast(t("Removed from favorites"));
    }
  };





  const handleBack = () => {
    if (searchParams.has("shared_item") || !location.state?.from) {
      navigate(`/${tableName}/${tableQr}/menus?lang=${searchParams.get("lang") || searchParams.get("selectedLang") || getLocalStorageMenuItem("lang") || "en"}&t=${searchParams.get("t") || ""}`);
    } else {
      navigate(-1);
    }
  };

  const handleOpenToast = (message, status) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = status === undefined ? true : status;
    toast.message = message;
    setToastSettings(toast);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setToastSettings({ open: false, message: "", success: false });
  };

  const onImageError = (e) => {
    e.target.src = no_image;
  };


  const handleOrder = (status, e) => {
    setFavClickCount(favClickCount - 1);
    if (menuTree?.details?.is_available) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isFacebook = userAgent.includes('facebook') || userAgent.includes('fbav');
      const isInstagram = userAgent.includes('instagram');

      if (isFacebook || isInstagram) {
        if (/iphone|ipad|ipod/.test(userAgent)) {
          window.location.href = `googlechromes://${window.location.href.replace(/^https?:\/\//, '')}`;
          setTimeout(() => {
            window.location.href = `safari://${window.location.href.replace(/^https?:\/\//, '')}`;
          }, 500);

          setTimeout(() => {
            window.location.href = window.location.href;
          }, 1000);
        }
        else {
          window.location.href = `intent://${window.location.href.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
          setTimeout(() => {
            window.location.href = window.location.href;
          }, 500);
        }
      } else {
        setOpen(status);
      }
    } else {
      handleOpenToast(t("This menu is not avialable, check menu opining hours in the home screen"), false);
    }


  };

  useEffect(() => {
    window.scrollTo(0, 0);

    loadTreeData();

    if (divRef.current) {
      const width = divRef.current.offsetWidth;
      setDivWidth(width);
    }
  }, []);

  useEffect(() => {
    if (!getLocalStorageMenuItem("gustToken")) {
      setLocalStorageMenuItem("gustToken", generateRandomToken(25));
    }
    document.body.style.direction = "rtl";
  }, []);

  if (loading || loadingTree) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  return (
    <div
      className={`main-items min-vh-100`}
      style={{
        color: setMobileTextColor(),
        backgroundColor: setMobileBackColor(),
        direction: "ltr",
      }}
    >
      <Container fluid>
        <div className="row">
          <div className="col-lg-8 d-none d-lg-block">
            <div className="mt-5 text-center d-flex-justify-content-center align-items-center">
              <div style={{ marginTop: "15%", left: "25%", position: "fixed" }}>
                <img
                  src={VenuePublicDetails?.logo}
                  className="me-4"
                  style={{ width: "250px", height: "250px" }}
                  onError={onImageError}
                />
                <h1 className="mt-4 head-font">
                  {VenuePublicDetails?.venu_name}
                </h1>
              </div>
            </div>
          </div>
          <div className="col-lg-4 ms-auto p-0" ref={divRef}>
            <div className="position-relative min-vh-100">
              <Carousel>
                <Carousel.Item>

                  <div style={{ position: 'relative' }}>
                    {itemData?.image ? (
                      <img
                        className="d-block w-100 slide-image h-50"
                        alt="First slide"
                        src={itemData?.image}
                        onError={onImageError}
                        style={{ cursor: 'pointer' }}
                        onClick={toggleImageZoom}
                      />
                    ) : (
                      <img
                        className="d-block w-100 slide-image h-50"
                        alt="First slide"
                        src={no_image}
                        style={{ cursor: 'pointer' }}
                        onClick={toggleImageZoom}
                      />
                    )}

                    {/* Magnifier icon */}
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '50px',
                        right: '20px',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        borderRadius: '50%',
                        padding: '8px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onClick={toggleImageZoom}
                    >
                      <ZoomInIcon style={{ color: 'white' }} />
                    </div>
                  </div>
                  <Button
                    className={`fw-bold back fw-bold ${getLocalStorageMenuItem("lang") === "ar" ||
                      getLocalStorageMenuItem("lang") === "fa"
                      ? "end-0"
                      : "start-0"
                      }`}
                    style={{
                      backgroundColor: "#ffffff",
                      color: setMobileCardBorderColor(),
                      border: "1px solid " + setMobileCardBorderColor(),
                      borderRadius: "8px",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    onClick={handleBack}
                  >
                    {getLocalStorageMenuItem("lang") === "ar" ||
                      getLocalStorageMenuItem("lang") === "fa" ? (
                      // <ArrowForwardIosOutlined />
                      <SvgDynamicIconComponent
                        icon_name="back"
                        is_arabic_lang={
                          getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                        }
                        color={setMobileCardBorderColor()}
                      />
                    ) : (
                      // <ArrowBackIosOutlined />
                      <SvgDynamicIconComponent
                        icon_name="back"
                        is_arabic_lang={
                          getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                        }
                        color={setMobileCardBorderColor()}
                      />
                    )}{" "}
                    <Link to="/selection" />
                  </Button>
                  <div>
                    <RWebShare
                      data={{
                        text: t("If You Like It Share It With Friends"),
                        url:
                          window.location.href +
                          (window.location.href.includes("?") ? "&" : "?") +
                          (searchParams.get("selectedLang")
                            ? ""
                            : "selectedLang=" + getLocalStorageMenuItem("lang") + "&") +
                          "shared_item"
                      }}
                      sites={[
                        "facebook",
                        "twitter",
                        "whatsapp",
                        "reddit",
                        "telegram",
                        "linkedin",
                        "mail",
                        "copy",
                        "vk",
                        "okru",
                      ]}
                    >
                      <Button
                        className={`fw-bold share ${getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa"
                          ? "start-0"
                          : "end-0"
                          }`}
                        style={{
                          backgroundColor: "#ffffff",
                          color: setMobileCardBorderColor(),
                          border: "1px solid " + setMobileCardBorderColor(),
                          borderRadius: "8px",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? (
                          <SvgDynamicIconComponent
                            icon_name="share"
                            is_arabic_lang={
                              getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa"
                            }
                            color={setMobileCardBorderColor()}
                          />
                        ) : (
                          <SvgDynamicIconComponent
                            icon_name="share"
                            is_arabic_lang={
                              getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa"
                            }
                            color={setMobileCardBorderColor()}
                          />
                        )}
                      </Button>
                    </RWebShare>

                  </div>
                </Carousel.Item>
              </Carousel>



              <div
                className="item-main-info-style"
                style={{ backgroundColor: setMobileBackColor() }}
              >
                <MianInfo
                  order_ability={menuTree?.details?.order_ability || false}
                  sympoleData={sympoleData}
                  item={itemData || []}
                  selected={selected}
                  calorie={calorie}
                  tableName={tableName}
                  tableQr={tableQr}
                  updataItem={updataItem}
                  favorites={favorites}
                  handleFavorite={handleFavorite}
                  handleSelected={handleSelected}
                  width={divWidth}
                  handleOrder={handleOrder}
                  open={open}
                  treeData={menuTree || false}
                  handleOpenToast={handleOpenToast}
                />

                <OrderItem
                  container={divRef}
                  item={itemData}
                  currency={sympoleData}
                  selected={priceOption}
                  handleOpenToast={handleOpenToast}
                  width={divWidth}
                  handleBack={handleBack}
                  tableName={tableName}
                  tableQr={tableQr}
                  handleOrder={handleOrder}
                  open={open}
                  close={() => setOpen(false)}
                />
              </div>
            </div>
          </div>
        </div>
        <Toast
          open={toastSettings.open}
          message={toastSettings.message}
          resetToast={handleCloseToast}
          success={toastSettings.success}
        />


        <LoadingTreeDataDialog openTreeDialogFlag={loadingTreeDialog} tableName={tableName} tableQr={tableQr} />



      </Container>

      <Dialog
        open={isImageZoomed}
        onClose={toggleImageZoom}
        maxWidth={false}
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            margin: 0,
            maxWidth: '100vw',
            maxHeight: '100vh',
            width: '100vw',
            height: '100vh'
          }
        }}
        style={{
          backdropFilter: 'blur(5px)',
          padding: 0,
          margin: 0
        }}
      >
        <DialogContent
          style={{
            padding: 0,
            margin: 0,
            backgroundColor: 'rgba(0,0,0,0.9)',
            height: '100vh',
            width: '100vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'auto'
          }}
        >
          <div style={{
            position: 'relative',
            padding: 0,
            margin: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img
              src={itemData?.image || no_image}
              alt={itemData?.name || 'Item image'}
              style={{
                maxWidth: 'none', // Remove width constraints
                maxHeight: 'none', // Remove height constraints
                width: 'auto',
                height: 'auto',
                minWidth: '90vw', // Increased for even larger display
                minHeight: '90vh',
                objectFit: 'contain', // Changed back to contain to show full image
                cursor: 'zoom-out',
                borderRadius: '8px',
                // Optional: Add transform for even more control
                // transform: `scale(${zoomLevel}) translate(${panPosition.x}px, ${panPosition.y}px)`
              }}
              onClick={toggleImageZoom}
              onError={onImageError}
            />

            {/* Close zoom button */}
            <div
              style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                backgroundColor: 'rgba(255,255,255,0.9)',
                borderRadius: '50%',
                padding: '12px',
                cursor: 'pointer',
                zIndex: 9999,
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
              }}
              onClick={toggleImageZoom}
            >
              <ZoomOutIcon style={{ color: '#333' }} />
            </div>

            {/* Optional: Add a backdrop click to close */}
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: -1
              }}
              onClick={toggleImageZoom}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Item;
